export default "__VITE_ASSET__C3pRAIJo__"